import React from 'react';
import './App.css';
import Layout from './common/components/Layout';
import { RouterConfig } from './routes/RouterConfig';
import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { ThemeProvider } from '@mui/material/styles';
import { themeOptions } from './style/Theme';
import SuccessSnackbar from './common/snackbar/SuccessSnackbar';
import InfoSnackbar from './common/snackbar/InfoSnackbar';
import WarningSnackbar from './common/snackbar/WarningSnackbar';
import ErrorSnackbar from './common/snackbar/ErrorSnackbar';
import usePageTracking from './common/utils/usePageTracking';

let theme = createTheme(themeOptions);
theme = responsiveFontSizes(theme, { factor: 4 });

function App() {
  usePageTracking();

  return (
    <div className='App'>
      <ThemeProvider theme={theme}>
        <Layout>
          <RouterConfig />
        </Layout>
        <SuccessSnackbar />
        <InfoSnackbar />
        <WarningSnackbar />
        <ErrorSnackbar />
      </ThemeProvider>
    </div>
  );
}

export default App;
